/**
 * SubmitBug (Help) screen styles - V3 Design
 */

import { StyleSheet, Dimensions } from 'react-native'
import { heightPercentageToDP as hp, widthPercentageToDP as wp } from 'react-native-responsive-screen';

import { fonts } from '../fonts';
import AppStyles from '../../AppStyles';

const screenWidth = Dimensions.get('window').width;

const styles = StyleSheet.create({
  // V3: Main content container
  innerContainer: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: hp(2),
    backgroundColor: AppStyles.colorSet.whiteColor,
  },
  // V3: Page title
  title: {
    marginBottom: hp(1),
    width: screenWidth > 800 ? '70%' : '100%',
    alignSelf: screenWidth > 800 ? 'center' : 'flex-start',
  },
  // V3: Section container (centered on desktop)
  sectionContainer: {
    width: screenWidth > 800 ? '70%' : '100%',
    alignSelf: screenWidth > 800 ? 'center' : 'stretch',
    marginBottom: hp(2),
  },
  // V3: Section label
  sectionLabel: {
    marginBottom: hp(0.5),
  },
  // V3: Contact info card
  contactCard: {
    backgroundColor: '#F5F5F5',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E5E5E5',
    paddingVertical: 14,
    paddingHorizontal: 16,
    marginBottom: hp(2),
  },
  // V3: Text input container
  orangeContainer: {
    backgroundColor: '#F5F5F5',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E5E5E5',
    height: hp(25),
    width: '100%',
  },
  // V3: Text input
  textInput: {
    width: '100%',
    textAlign: 'left',
    textAlignVertical: 'top',
    fontFamily: fonts.POPPINS.medium,
    fontSize: 16,
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 14,
    color: AppStyles.colorSet.textPrimary,
  },
  // V3: Placeholder text
  placeholder: {
    position: 'absolute',
    top: 14,
    left: 16,
    color: AppStyles.colorSet.textMuted,
    fontSize: 16,
    fontFamily: fonts.POPPINS.regular,
  },
  buttonDelete: {
    cursor: 'pointer',
    backgroundColor: '#FF1111',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 12,
    height: hp(6.8),
    width: '50%',
    alignSelf: 'center',
    marginTop: hp(2.5),
  },
  buttonAdd: {
    cursor: 'pointer',
    backgroundColor: '#11FF11',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 12,
    height: hp(6.8),
    width: '50%',
    alignSelf: 'center',
    marginTop: hp(2.5),
  },
  // V3: Submit button
  submitButton: {
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    backgroundColor: AppStyles.colorSet.brandPrimary,
    borderRadius: 12,
    marginTop: hp(2),
    width: '100%',
    height: hp(6.8),
  },
  // V3: Disabled button state
  submitButtonDisabled: {
    backgroundColor: 'rgba(255, 196, 81, 0.5)',
    cursor: 'default',
  },
  // V3: Image upload as text link
  imageUploadLink: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: hp(1.5),
    marginBottom: hp(0.5),
  },
  // V3: FAQ section styles
  faqContainer: {
    width: screenWidth > 800 ? '70%' : '100%',
    alignSelf: screenWidth > 800 ? 'center' : 'stretch',
    marginTop: hp(2),
    marginBottom: hp(3),
  },
  faqHeading: {
    marginBottom: hp(1),
  },
  accordionText: {
    marginLeft: 15,
    marginBottom: 10,
    lineHeight: 22,
  },
  faqSingleScreenshot: {
    alignSelf: 'center',
    maxWidth: 300,
    width: wp(60),
    height: hp(55),
    borderRadius: 8,
  },
  faqMultiScreenshotContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginVertical: 8,
  },
  faqMultiScreenshot: {
    maxWidth: 300,
    width: wp(40),
    height: hp(35),
    borderRadius: 8,
  },
  // V3: Separator
  separator: {
    height: 1,
    backgroundColor: '#E5E5E5',
    marginVertical: hp(2),
  },
  // Legacy - kept for compatibility
  heading: {
    marginTop: hp(1),
  },
  imageUploadButton: {
    height: 70,
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: AppStyles.colorSet.brandPrimary,
    borderRadius: 12,
    marginVertical: hp(1),
  },
  Chip: {
    marginHorizontal: hp(0),
    backgroundColor: AppStyles.colorSet.brandPrimaryMedium,
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 100,
    borderColor: 'rgb(0,0,0)',
    borderWidth: 1,
  },
  ChipSelected: {
    marginHorizontal: hp(0),
    backgroundColor: AppStyles.colorSet.brandPrimary,
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 100,
    borderColor: 'rgb(0,0,0)',
    borderWidth: 1,
  },
  ChipAdd: {
    marginHorizontal: hp(0),
    borderRadius: 100,
    backgroundColor: '#CCCCCC',
    justifyContent: 'center',
    flex: 1,
    borderColor: 'rgb(0,0,0)',
    borderWidth: 1,
    minHeight: hp(3),
  },
  ChipText: {
    marginHorizontal: hp(2),
  },
  ChipDeleteText: {
    marginRight: hp(1),
    borderRadius: 100,
  },
  container: {
    height: '100%',
    position: 'absolute',
    zIndex: -1,
  },
  baseContainer: {
    backgroundColor: AppStyles.colorSet.whiteColor,
    flex: 1,
  },
  tallcontainer: {
    backgroundColor: AppStyles.colorSet.whiteColor,
    flex: 1,
    height: hp(30),
  },
  buttonText: {
    marginVertical: hp(1.8),
    paddingVertical: hp(0.8),
    paddingHorizontal: wp(0.8),
    textAlign: 'center'
  },
  error: {
    color: AppStyles.colorSet.error,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

export default styles;
